// src/auth.js

const AUTH_KEY = 'console_is_logged_in';

// 👉 change these to your actual credentials
const USERNAME = 'admin';
const PASSWORD = 'Gray909!automate';

// Use sessionStorage so login dies when the tab/window is closed
const STORAGE = window.sessionStorage;

export function login(username, password) {
  return username === USERNAME && password === PASSWORD;
}

export function setLoggedIn(value) {
  if (value) {
    STORAGE.setItem(AUTH_KEY, 'true');
  } else {
    STORAGE.removeItem(AUTH_KEY);
  }
}

export function isLoggedIn() {
  return STORAGE.getItem(AUTH_KEY) === 'true';
}

export function logout() {
  // Clear our session flag
  STORAGE.removeItem(AUTH_KEY);

  // Optional: also clear any previous localStorage flag
  // (in case you used it earlier in development)
  try {
    window.localStorage.removeItem(AUTH_KEY);
  } catch (e) {
    // ignore if not available
  }
}
